import {NetworkEnums} from '../../../../shared/GameEnums'
import {MatchmakingStatusUpdate} from '../../../../shared/matchmaking/MatchmakingInterfaces'
import {SocketActionController} from './SocketActionController'
import {BaseError} from '../../../../shared/errors/BaseError'
import MatchmakingState = NetworkEnums.MatchmakingState
import MatchmakingStateUpdateData = NetworkEnums.MatchmakingStateUpdateData
import {SocketMatchmakingSend} from './SocketMatchmakingSend'
import type {SocketController} from './SocketController'

export class SocketMatchmakingListen {
    readonly socketActionController: SocketActionController
    // eslint-disable-next-line func-call-spacing
    private readonly matchmakingStateHandlers = new Map<MatchmakingState, (data: any) => void>()

    constructor(socketController: SocketController, socketActionController: SocketActionController) {
        this.socketActionController = socketActionController

        socketController.setStateHandler(NetworkEnums.State.MatchmakingStateUpdate, (data: MatchmakingStateUpdateData) => {
            this.matchmakingStateHandlers.get(data.type)?.(data.payload)
        })

        this.matchmakingStateHandlers.set(MatchmakingState.MatchmakingUpdate, (matchmakingStatusUpdate: MatchmakingStatusUpdate) => {
            this.socketActionController.onMatchmakingUpdate(matchmakingStatusUpdate)
        })

        this.matchmakingStateHandlers.set(MatchmakingState.MatchmakingError, (error: BaseError) => {
            this.socketActionController.onMatchmakingError(error)
        })

        this.matchmakingStateHandlers.set(MatchmakingState.MatchmakingShowPreRollAd, (data: any) => {
            this.socketActionController.onMatchmakingShowPreRollAd()
        })

        this.matchmakingStateHandlers.set(MatchmakingState.MatchmakingDisableAdblock, (data: any) => {
            this.socketActionController.onMatchmakingDisableAdblock()
        })

        this.matchmakingStateHandlers.set(MatchmakingState.MatchmakingReconnect, (data: any) => {
            SocketMatchmakingSend.sendFindGame()
        })
    }
}
